import { Observable } from "rxjs";
import { VehicleType } from "../domain";
import { VehicleGroupDto } from "../domain/requests/vehicle-group/create-edit-vehicle-group-request.js";

export abstract class VehicleGroupRepository {
    abstract getVehicleGroups(planId:string): Observable<VehicleGroupDto[]>;
    abstract createVehicleGroup(request: VehicleGroupDto[]): Observable<boolean>;
    abstract updateVehicleGroup(request: VehicleGroupDto[]): Observable<boolean>;
    abstract deleteVehicleGroup(id: string): Observable<boolean>;
    abstract getVehicleTypes(): Observable<VehicleType[]>

} 